<template>
  <div class="swagger_ui_component">
    <div class="p-4">

      <div class="row mt-2" style="padding-top: 10px; margin-bottom: 30px; vertical-align: middle;">
        <div class="col-3">
          <span class="navbar-brand">
            <img alt="Logo" width="150px"
              src="https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/koko_logo_9613b6f06a.png?updated_at=2023-05-11T04:39:19.139Z" />
          </span>
        </div>
        <div class="col-9">
          <h1 style="margin-top: 2%;">
            <b>Api Documentation For Koko Microservices</b>
          </h1>
        </div>
      </div>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 py-5">
        <div class="col d-flex align-items-start">
          <div>
            <h3 class="fw-bold mb-0 fs-4">
              <a href="https://qaapi.paykoko.com/api/v2/auth/api-docs/" target="_blank">Auth Services</a>
            </h3>
            <p>Providing Description auth related api's</p>
          </div>
        </div>
        <div class="col d-flex align-items-start">
          <div>
            <h3 class="fw-bold mb-0 fs-4">
              <a href="https://qaapi.paykoko.com/api/merchants/api-docs/" target="_blank">Merchant Services</a>
            </h3>
            <p>Providing Description merchant related api's</p>
          </div>
        </div>
        <div class="col d-flex align-items-start">
          <div>
            <h3 class="fw-bold mb-0 fs-4">
              <a href="https://qaapi.paykoko.com/api/v2/consumer/api-docs/" target="_blank">Consumer Services</a>
            </h3>
            <p>Providing Description offile consumenr related api's</p>
          </div>
        </div>
        <div class="col d-flex align-items-start">
          <div>
            <h3 class="fw-bold mb-0 fs-4">
              <a href="https://qaapi.paykoko.com/api/v2/payment/api-docs/" target="_blank">Payment Services</a>
            </h3>
            <p>Providing Description payment related api's</p>
          </div>
        </div>
        <div class="col d-flex align-items-start">
          <div>
            <h3 class="fw-bold mb-0 fs-4">
              <a href="https://qaapi.paykoko.com/api/v2/notification/api-docs/" target="_blank">Notification
                Services</a>
            </h3>
            <p>Providing Description notification related api's</p>
          </div>
        </div>
        <div class="col d-flex align-items-start">
          <div>
            <h3 class="fw-bold mb-0 fs-4">
              <a href="https://qaapi.paykoko.com/bnpl-operator-portal-service/api/api-docs/" target="_blank">Operator
                Portal Service</a>
            </h3>
            <p>Providing Description Operator Portal Service related api's</p>
          </div>
        </div>
      <div class="col d-flex align-items-start">
        <div>
          <h3 class="fw-bold mb-0 fs-4">
            <a href="https://qaapi.paykoko.com/bnpl-reporting-service/api/api-docs/" target="_blank">Reporting Service</a>
          </h3>
          <p>Providing Description Reporting Service related api's</p>
        </div>
      </div>
      <div class="col d-flex align-items-start">
        <div>
          <h3 class="fw-bold mb-0 fs-4">
            <a href="https://qaapi.paykoko.com/bnpl-payment-scheduler-service/api/api-docs/" target="_blank">Payment Scheduler Service</a>
          </h3>
          <p>Providing Description Payment Scheduler Service related api's</p>
        </div>
      </div>
      <div class="col d-flex align-items-start">
        <div>
          <h3 class="fw-bold mb-0 fs-4">
            <a href="https://qaapi.paykoko.com/bnpl-scheduled-payment-gateway-service/api/api-docs/" target="_blank">Payment Scheduler Gateway Service</a>
          </h3>
          <p>Providing Description Payment Scheduler Gateway Service related api's</p>
        </div>
      </div>
      <div class="col d-flex align-items-start">
        <div>
          <h3 class="fw-bold mb-0 fs-4">
            <a href="https://qaapi.paykoko.com/api/shopify/api-docs/" target="_blank">Shopify Service</a>
          </h3>
          <p>Providing Description Shopify Service related api's</p>
        </div>
      </div>             
    </div>
  </div>
  </div>
</template>
  
  <script>
  
  export default {
    name: "SwaggerUI",
    components: {
  
    },
    mounted() {
      document.title = "Buy Now Pay Later with Koko";
    },
    created(){
  
    },
  }
  </script>
  
  <style scoped>

  </style>
  
  